import ChartController from "./chart_controller.js"

// Connects to data-controller="chart-planungssimulation"
export default class extends ChartController {
	static targets = ["data", "checkboxNominalReal"]

	// Diese Methode wird für den Wechsel zwischen Real- und Nominalvermögen im Chart verwendet.
	changeNominalReal({ currentTarget }) {
		const format = currentTarget.checked ? "real" : "nominal"
		const chart = this.chart.chart

		chart.series.forEach((serie) => {
			if (format === "nominal") {
				serie.setData(serie.options.dataNominal, false)
			} else if (format === "real") {
				serie.setData(serie.options.dataReal, false)
			}
		})

		// Chart-Animation
		chart.options.chart.werteDarstellung = format
		chart.redraw({ duration: chartAnimationDuration })
	}
}
